// Utils
import { findKeyByPriority } from './utils/findKeyByPriority';
/**
 * Finds the first key and value that meets a check in an object
 *
 * @template T extends object
 * @template K extends keyof T
 * @param {T} data Data to find the value
 * @param {(keyof T)[]} columnsByPriority Array of keys in order of priority to search the data object
 * @param {(value: T[keyof T]) => boolean} valueCheck Predicate function each value found by data[column]
 *
 * @returns {KeyAndValue<T, keyof T> | null} The key and value as JSON
 */
export var findKeyAndValueByPriority = function (data, columnsByPriority, valueCheck) {
    var key = findKeyByPriority(data, columnsByPriority, valueCheck);
    if (key !== undefined) {
        return {
            key: key,
            value: data[key],
        };
    }
    return null;
};
//# sourceMappingURL=findKeyAndValueByPriority.js.map